import { useLanguage } from "@/context/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] border-t border-[#27272A] py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-gradient-to-br from-[#FF6B00] to-[#FF8533] rounded-xl flex items-center justify-center">
                <span className="text-white font-['Outfit'] font-bold text-lg tracking-tighter">EG</span>
              </div>
              <div className="flex flex-col">
                <span className="text-lg font-bold text-white font-['Outfit'] tracking-tight leading-none">EG BOUW</span>
                <span className="text-[8px] text-[#A1A1AA] tracking-[0.15em] uppercase">Vakmanschap sinds 2005</span>
              </div>
            </div>
            <p className="text-[#A1A1AA] text-sm">{t("footer_desc")}</p>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <div className="space-y-2 text-[#A1A1AA] text-sm">
              <p>Torenallee 101, 5617BR Eindhoven</p>
              <p>Tel: <a href="tel:0681025105" className="hover:text-[#FF6B00]">06 81 02 51 05</a></p>
              <p>Email: <a href="mailto:info@ella-gold.com" className="hover:text-[#FF6B00]">info@ella-gold.com</a></p>
              <p>KvK: 99681293</p>
            </div>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-4">{t("footer_legal")}</h4>
            <div className="space-y-2 text-[#A1A1AA] text-sm">
              <p><a href="/privacy" data-testid="footer-privacy-link" className="hover:text-[#FF6B00] transition-colors">{t("footer_privacy")}</a></p>
              <p><a href="/voorwaarden" data-testid="footer-terms-link" className="hover:text-[#FF6B00] transition-colors">{t("footer_terms")}</a></p>
              <p><a href="/disclaimer" data-testid="footer-disclaimer-link" className="hover:text-[#FF6B00] transition-colors">{t("footer_disclaimer")}</a></p>
            </div>
          </div>
        </div>
        
        <div className="border-t border-[#27272A] pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#A1A1AA] text-sm">
            &copy; {new Date().getFullYear()} EG Bouw. {t("footer_rights")}
          </p>
          <p className="text-[#A1A1AA] text-xs">
            BTW: NL005404414B27 | IBAN: NL22INGB0116174293
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
